import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, map } from 'rxjs';
import { AppService } from './app.service';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { environment } from '@environments/environment';
import { LoaderService } from './loader.service';
import { WebStorageService } from './webstorage.service';
import { Utils } from '../helper/Utils';

@Injectable({
  providedIn: 'root'
})
export class FormDataService {
  private formData = {};
  private formInvalid: boolean = false;
  private clientAbbreviation: string = Utils.fetch('clientAbbreviation');

  constructor(private http: HttpClient, private loaderService: LoaderService, private webStorageService: WebStorageService){

  }
  updateFormData(key: string, data: any) {
    this.formData[key] = data;
  }
  clearFormData() {
    this.formData = {};
  }
  getFormDataByKey(key:string) {
    return this.formData[key]??this.formData[key];
  }

  getFormData() {
    return this.formData;
  }

  isValidField(value: any, validation: any): boolean {
    switch (validation.validator) {
      case 'isRequired':
        if(Array.isArray(value)){
          return value && value.length > 0;
        }
        else if(value instanceof Date){
          return value!=null;
        }
        else
        {
          return value && value.trim().length > 0;
        }
      case 'maxLength':
        return value && value.length <= validation.value;
      case 'minLength':
        return value && value.length >= validation.value;
      case 'isEmail':
        let pattern = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return pattern.test(value);
      default:
        return true;
    }
  }

  validateForm(conf, formDataHasErrorEmitter) {
    this.formInvalid = false;
    this.validateFields(conf);
    conf.Groups.forEach(group => {
      group.Fields.forEach(fieldObj => {
        if (fieldObj.invalid) {
          this.formInvalid = true;
          console.log("Validation falied", fieldObj.Name);
          //return;
        }
      })
    })

    if (this.formInvalid) {
      conf.hasError = true;
      formDataHasErrorEmitter.emit(true);
    } else {
      conf.hasError = false;
      formDataHasErrorEmitter.emit(false);
    }
  }

  isFormValid(conf) {
    let formInvalid = false;
    this.validateFields(conf)
    conf.Groups.forEach(group => {
      group.Fields.forEach(fieldObj => {
        if (fieldObj.invalid) {
          formInvalid = true;
          console.log(conf.TabName +" -> " + group.GroupName + " ->", fieldObj.Name +" IS INVALID");
          //return;
        }
      })
    })
    conf.hasError = formInvalid;
  }

  fieldExists(fields, fieldName) {
    let fieldexist = false;
    fields.forEach(element => {
      if (element.Name === fieldName) {
        fieldexist = true;
      }
    });
    return fieldexist;
  }

  getFieldCount(conf, groupName) {
    let count = 0;
    conf.Groups.forEach(group => {
      if (group.GroupName === groupName) {
        count = group.Fields.length + 1;
      }
    });
    return count;
  }

  generateFieldID(conf) {
    let maxFieldID = 0;
    conf.Groups.forEach(group => {
      group.Fields.forEach((field, i) => {
        if (Number(field.fieldID) > maxFieldID) {
          maxFieldID = field.fieldID;
        }
      })
    })
    return (Number(maxFieldID) + 1).toString();
  }

  generateFieldIDFromCD(caseDetails) {
    let maxFieldID = 0;
    caseDetails.Tabs.forEach((cdObj: any) => {
      cdObj.Groups.forEach(group => {
        group.Fields.forEach((field, i) => {
          if (Number(field.fieldID) > maxFieldID) {
            maxFieldID = field.fieldID;
          }
        })
      })
    });
    return (Number(maxFieldID) + 1).toString();
  }

  getConf(caseDetailsConf, tabName) {
    let conf: any;
    caseDetailsConf.Tabs.forEach((cdObj: any) => {
      if (cdObj.TabValue === tabName) {
        conf = cdObj;
      }
    });
    return conf;
  }

  anyTabFormDataHasError(caseDetailsConf) {
    caseDetailsConf.Tabs.forEach((confObj: any) => {
      //console.log("validating", confObj.TabName);
      this.isFormValid(confObj);
    });

    let hasError = false;
    //debugger;
    caseDetailsConf.Tabs.forEach((cdObj: any) => {
      if (cdObj.hasError) {
        hasError = true;
        return;
      }
    });  

    //hasError = this.isDispositionValid(caseDetailsConf);

    let anyCaseHasError = sessionStorage.getItem('ache');
    if(anyCaseHasError === 'true'){
      hasError = true;
    }

    return hasError;
  }
  validateCaseDetailTabHaserror(caseDetailsConf) {
    caseDetailsConf.Tabs.forEach((confObj: any) => {
      //console.log("validating", confObj.TabName);
      this.isFormValid(confObj);
    });

    let hasError = false;
    //debugger;
    caseDetailsConf.Tabs.forEach((cdObj: any) => {
      if (cdObj.hasError && cdObj.TabName == 'Cases') {
        hasError = true;
        return;
      }
    });  

    //hasError = this.isDispositionValid(caseDetailsConf);

    let anyCaseHasError = sessionStorage.getItem('ache');
    if(anyCaseHasError === 'true'){
      hasError = true;
    }

    return hasError;
  }
  validateFields(conf){
    conf.Groups.forEach(group => {
      group.Fields.forEach(fieldObj => {
        //this.validateField(field, field.value, formDataHasErrorEmitter);

        let validator = [];
        if (fieldObj.isRequired) {
          validator.push('isRequired');
        }
        if (fieldObj.maxLength) {
          validator.push('maxLength');
        }
        if (fieldObj.minLength) {
          validator.push('minLength');
        }
        if (fieldObj.pattern) {
          validator.push('pattern');
        }

        fieldObj.invalid = false;

        if(!fieldObj.viewMode){
        // More validations to be added
          validator.forEach(item => {
            let validation = { validator: item, value: fieldObj[item] };
            let isValid;
            //validation code added for Case Assigner
            if(fieldObj.fieldType=='CaseAssigner')
            {
              isValid=this.isValidCaseAssigner(fieldObj.value);
            }
            else
            {
              isValid = this.isValidField(fieldObj.value, validation);
            }
            let errItem = item + "Error";
            fieldObj[errItem] = false;
            if (!isValid) {
              // Set respective validator errors in field object
              fieldObj[errItem] = true;
              fieldObj.invalid = true;

              if(this.clientAbbreviation == 'BCH' || this.clientAbbreviation == 'PCH' || this.clientAbbreviation == 'AHP'){
                // Parent is mandatory and child also mandatory
                if(fieldObj.isRequired && fieldObj.children){
                  fieldObj.children.childFields.forEach(childField => {
                    childField = this.getFieldByID(childField.fieldID, conf);
                    if(!fieldObj.value && childField.isRequired){
                      childField.invalid = true; 
                       if(childField.fieldType=='CaseAssigner')
                       {
                          childField.value='-1|-1';
                          this.formData[childField.Name] = '-1|-1';
                       }else{
                          childField.value='';
                          this.formData[childField.Name] = '';
                       }
                      childField[errItem] = true;
                    }
                  })
                }
              }

              // Parent is optional but child is mandatory?
              if(!fieldObj.isRequired && fieldObj.children){
                fieldObj.children.childFields.forEach(childField => {
                  childField = this.getFieldByID(childField.fieldID, conf);
                  if(!fieldObj.value && childField.isRequired){
                    childField.invalid = false; // Make child field optional
                    childField[errItem] = false;
                  }
                })
              }
              //----------------------------------------
            }
          })
        }
      })
    })
  }
  isValidCaseAssigner(value)
  {
    let queue=value.substring(0, value.indexOf("|"));
    let agent=value.substring(value.indexOf("|") + 1);
    if(agent!='-1' && queue!='-1' && value!="")
      return true;
    else
      return false;
  }
  getData(dsUrl){
    let params = new HttpParams();
      const baseUrl = dsUrl?.split('?');
      let iscompanyfieldavailable = false;
    if (baseUrl && baseUrl?.length > 1) {
      const all = baseUrl[1]?.split('&&');
        all?.forEach(element => {
          const temp = element?.split('=');
          if(temp){
            const key = temp[0];
            const value = temp[1];
            if (key && value) {
              params = params.set(key, value);
              }
              if (key == 'company') {
                  iscompanyfieldavailable = true;
              }
          }
      });
      }
      if (!iscompanyfieldavailable) {
          params = params.set('company', this.webStorageService.getItemFromSessionStorage('company'));
      }
    return this.http.get<any>(environment.apiUrl + baseUrl[0],{params}).pipe(
      map(res => {
        this?.loaderService?.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }

  uploadFile(file: any) {
    const formData = new FormData();
    const company = this.webStorageService.getItemFromSessionStorage('company');
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    //let fileName = "Onvida_"+ company + "_" +  new Date().toISOString().split('T')[0] + "_" + Date.now() + "." + fileExt;
    const fileName = file.name;
    formData.append('file', file, fileName);
    formData.append('company', company);
    formData.append('user', JSON.stringify(user));
    formData.append('fileID', '0');
    formData.append('description', null);
    formData.append('fixFileName', 'false');
    formData.append('isPublic', 'false');
  
    //console.log('formData', formData);
    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/privatefiles/SaveFile`, formData).pipe(
      map(res => {
        this.loaderService.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }

  
  getFilesByID(fileIDs: any[]) {
    let pl: any = {};
    pl.company = this.webStorageService.getItemFromSessionStorage('company');;
    pl.user = this.webStorageService.getItemFromSessionStorage('currentUser');;
    pl.fileIDs = fileIDs;
    pl.areDisabled = false;

    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/privatefiles/GetFilesByID`, pl).pipe(
      map(res => {
        this.loaderService.display(false);

        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }

  getFile(data) {
    const uc = { filePath: data };
    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/PrivateFilesApi`, uc).pipe(
      map(res => {
        this.loaderService.display(false);
        //res = {"Response":{"Data":true,"Status":1,"Message":null},"Status":1,"Message":null}
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }

  getFieldByID(fieldID, conf) {
    let targetField = {};
    conf.Groups.forEach(group => {
      group.Fields.forEach(field => {
        if (fieldID == field.fieldID) {
          targetField = field;
        }
      });
    });
    return targetField;
  }


  getCaseNotes(caseNotesId: any) {
    let payload: any = {};
    const company = this.webStorageService.getItemFromSessionStorage('company');
    payload.Company = company;
    payload.CaseNotesID = caseNotesId;

    return this.http.post<any>(`${environment.apiUrl}api/services/casenotes/GetCaseNotes`, payload).pipe(
      map(res => {
        this.loaderService.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }

  createCaseNotes(params: any) {
    let payload: any = params;

    const company = this.webStorageService.getItemFromSessionStorage('company');
    payload.Company = company;

    return this.http.post<any>(`${environment.apiUrl}api/services/casenotes/CreateCaseNotes`, payload).pipe(
      map(res => {
        this.loaderService.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }

  saveCaseNotes(caseNotesId: any, notes: any) {
    let payload: any = {};  
    const company = this.webStorageService.getItemFromSessionStorage('company');
    payload.Company = company;
    payload.CaseNotes = notes;
    payload.CaseNotesID = caseNotesId;

    return this.http.post<any>(`${environment.apiUrl}api/services/casenotes/SaveCaseNotes`, payload).pipe(
      map(res => {
        this.loaderService.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }
}
